import React, { Fragment } from 'react';

type SeparatorProps = { brand: string };

const FordSeparator = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            data-testid="breadcrumb-separator-ford"
        >
            <mask
                id="mask0_242_3035"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="17"
            >
                <g clipPath="url(#clip0_242_3035)">
                    <mask
                        id="mask1_242_3035"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="17"
                    >
                        <rect y="0.54541" width="16" height="16" fill="white" />
                    </mask>
                    <g mask="url(#mask1_242_3035)">
                        <path
                            d="M9.06654 8.5454L6.46654 5.9454C6.34431 5.82318 6.2832 5.66762 6.2832 5.47874C6.2832 5.28985 6.34431 5.13429 6.46654 5.01207C6.58876 4.88985 6.74431 4.82874 6.9332 4.82874C7.12209 4.82874 7.27765 4.88985 7.39987 5.01207L10.4665 8.07874C10.5332 8.1454 10.5804 8.21762 10.6082 8.2954C10.636 8.37318 10.6499 8.45651 10.6499 8.5454C10.6499 8.63429 10.636 8.71762 10.6082 8.7954C10.5804 8.87318 10.5332 8.9454 10.4665 9.01207L7.39987 12.0787C7.27765 12.201 7.12209 12.2621 6.9332 12.2621C6.74431 12.2621 6.58876 12.201 6.46654 12.0787C6.34431 11.9565 6.2832 11.801 6.2832 11.6121C6.2832 11.4232 6.34431 11.2676 6.46654 11.1454L9.06654 8.5454Z"
                            fill="black"
                        />
                    </g>
                </g>
            </mask>
            <g mask="url(#mask0_242_3035)">
                <g style={{ mixBlendMode: 'screen' }}>
                    <rect y="0.54541" width="16" height="16" fill="black" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_242_3035">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.54541)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

const LincolnSeparator = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            data-testid="breadcrumb-separator-lincoln"
        >
            <mask
                id="mask0_242_3850"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <g clipPath="url(#clip0_242_3850)">
                    <mask
                        id="mask1_242_3850"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                    >
                        <rect width="16" height="16" fill="white" />
                    </mask>
                    <g mask="url(#mask1_242_3850)">
                        <path
                            d="M9.2975 8L6.23083 4.93334L6.93333 4.23083L10.7025 8L6.93333 11.7692L6.23083 11.0667L9.2975 8Z"
                            fill="black"
                        />
                    </g>
                </g>
            </mask>
            <g mask="url(#mask0_242_3850)">
                <g style={{ mixBlendMode: 'screen' }}>
                    <rect width="16" height="16" fill="black" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_242_3850">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const Separator = ({ brand }: SeparatorProps): JSX.Element => {
    const getBrandSeparator = (brand: string) => {
        switch (brand) {
            case 'ford':
                return <FordSeparator />;
            case 'lincoln':
                return <LincolnSeparator />;
            default:
                return null;
        }
    };

    return <Fragment>{getBrandSeparator(brand)}</Fragment>;
};

export default Separator;
